import { Injectable, ElementRef } from '@angular/core';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import { DatePipe } from '@angular/common';

const EXCEL_EXTENSION = '.xlsx';
const CSV_EXTENSION = '.csv';
const CSV_TYPE = 'text/plain;charset=utf-8';

@Injectable()
export class ExportJsonService {
	constructor(private datePipe: DatePipe) {}

	public exportJsonToExcel(json: any[], fileName: string): void {
		const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
		const workbook: XLSX.WorkBook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
		XLSX.writeFile(workbook, fileName + EXCEL_EXTENSION);
	}

	public exportJsonToCsv(json: any[], fileName: string): void {
		const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
		const csvOutput: string = XLSX.utils.sheet_to_csv(worksheet);
		var blob = new Blob([csvOutput], { type: CSV_TYPE });
		FileSaver.saveAs(blob, fileName + CSV_EXTENSION);
	}

	public exportTable(elementId: string, filenameAddition: string, isCSV: boolean, exclude: any[]= []) {
		let dataArray = []; //will be a 2D array
		const table = document.getElementById(elementId);
		const rows: object = table.querySelectorAll("tr");
		let rowNumber = 0;

		for(const row in rows){
			const cells = rows[row].cells
			dataArray[rowNumber] = new Array();
			for(const cell in cells){
				const cellText = cells[cell].innerText
				if(cellText || cellText === "") dataArray[rowNumber].push(cellText);
			}
			rowNumber++;
		}
		
		let exportList = [];//will be an array of objects
		let headerRow = dataArray[0]
		for(let i=1; i < dataArray.length; i++) {//for each data row (student)
			exportList[i-1] = Object.fromEntries( headerRow.map((key, index) => [key, ""]) );
			for(let j=0; j < headerRow.length; j++) {//for each column
				exportList[i-1][headerRow[j]] = dataArray[i][j];
			}
		}

		for (let student of exportList){ //removing the View column
			for (let column of exclude) {
				delete student[column];
			}
		}

		const filenameDate = this.datePipe.transform(new Date(), 'YYYY-MM-dd');
		
		if(isCSV){
			this.exportJsonToCsv(exportList, filenameAddition+' '+filenameDate);
		} else {
			this.exportJsonToExcel(exportList, filenameAddition+' '+filenameDate);
		}
	}
}
